// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"43f29ccb","160":"ab7d9a90","208":"b27c9cad","293":"44d1d716","453":"2071a36c","516":"3441d223","519":"e707a404","917":"c4e0d97b","946":"3e611db2"}[chunkId] + ".chunk.js";
};